import { text } from '../text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faCalendarCheck, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faSquareEnvelope } from '@fortawesome/free-solid-svg-icons';
import { PropertyType, RoomType } from "../../src/types/types";


type Props = {
    review: PropertyType;
    isLast: boolean;
    onCalendarClick?: () => void;
};


export const PropertiyOwner: React.FC<Props> = ({ review, isLast, onCalendarClick }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                marginBottom: isLast ? 0 : 20,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: '#F9FAFC',
                borderRadius: 6,
                padding: 15,
                border: '1px solid ##EFEEFB',
            }}
        >
            <img
                src="https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
                alt='review'
                style={{ width: 50, height: 50, borderRadius: 35, marginRight: 10 }}
            />
            <div style={{ width: '100%' }}>
                <text.H5
                    style={{ marginBottom: 0 }}
                    numberOfLines={1}
                >
                    {review.property_name}
                </text.H5>
                <text.T14 style={{ color: "#7065F0" }}>
                    {/* {review.ownertype} */}
                    Owner

                </text.T14>
            </div>
            <div
                style={{
                    display: 'flex', gap: 20,
                    marginRight: 6
                }}>
                <div
                    style={{
                        width: 44,
                        height: 44,
                        backgroundColor: '#7065F0', // WhatsApp green
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={() => (window.location.href = "tel:+919999999999")}
                >
                    <FontAwesomeIcon icon={faPhone} style={{ color: 'white', width: 22, height: 22 }} />
                </div>
                <div
                    style={{
                        width: 44,
                        height: 44,
                        backgroundColor: '#ffc107',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={onCalendarClick}
                >
                    {/* <FontAwesomeIcon icon={faSquareEnvelope} style={{ color: 'white', width: 22, height: 22 }} /> */}
                    <FontAwesomeIcon icon={faCalendarCheck} style={{ color: 'black', width: 22, height: 22 }} />
                </div>
            </div>
        </div>
    );
};
